import { Button, Header, Icon, Message } from "semantic-ui-react";
import React, { useContext } from "react";

import { AuthContext } from "./AuthContextProvider";
import { Navigate } from "react-router-dom";
import { Role } from "../types";
import { useAuth0 } from "@auth0/auth0-react";

export const viableUserRoles = [
    Role.ServicingUser,
    Role.ServicingTrading,
    Role.Accounting,
    Role.AccountingAdmin,
    Role.GenericAdmin,
    Role.UWSupportSr
];

const CatchAllRedirect: React.FC = () => {
    const { userRoles, userHasAnyRole, userHasRole } = useContext(AuthContext);
    const { logout } = useAuth0();

    if (!userRoles) {
        return <Header color="grey" content="Checking permissions..." icon={<Icon name="cog" loading />} />;
    }

    if (!userHasAnyRole(viableUserRoles)) {
        return (
            <Message error>
                <Message.Header content="Error" />
                <br />
                Missing or invalid user roles.
                <br />
                <br />
                You must be in the Servicing role to access this application. Please contact the helpdesk for assistance.
                <br />
                <br />
                <Button compact type="button" color="grey" content="Sign out" onClick={() => logout()} />
            </Message>
        );
    }

    const getRedirectRoute = () => {
        if (userHasRole(Role.ServicingUser)) {
            return "/policy";
        } else if (userHasRole(Role.ServicingTrading)) {
            return "/trading-queue";
        } else if (userHasAnyRole([Role.Accounting, Role.AccountingAdmin])) {
            return "/billing-export";
        } else if (userHasAnyRole([Role.GenericAdmin, Role.UWSupportSr])) {
            return "/create-client";
        }
        throw new Error("No redirect route found");
    };

    return <Navigate to={getRedirectRoute()} />;
};

export default CatchAllRedirect;
